// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { ServicesDescriptionCoachingFocusFragmentDoc } from '../../../__generated-gql-types__/ServicesDescription.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BookHourlyCoachingFormCoachFragment = {
  __typename?: 'Coach';
  id: string;
  newExperience?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  mostRecentOrder?: {
    __typename?: 'Order';
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type BookHourlyCoachingFormCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
};

export type BookHourlyCoachingFormCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  hourlyOrder: Types.HourlyOrderInput;
  numberOfCharges: Types.Scalars['Int']['input'];
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type BookHourlyCoachingFormCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: { __typename?: 'Order'; id: string };
};

export type BookHourlyCoachingFormUpdateOrderMutationVariables = Types.Exact<{
  id: Types.Scalars['OrderUrn']['input'];
  hourlyOrder?: Types.InputMaybe<Types.HourlyOrderInput>;
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type BookHourlyCoachingFormUpdateOrderMutation = {
  __typename?: 'Mutation';
  updateOrder: { __typename?: 'Order'; id: string };
};

export type BookHourlyCoachingFormInitialLoadQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type BookHourlyCoachingFormInitialLoadQuery = {
  __typename?: 'Query';
  skus: {
    __typename?: 'SkuBatchResponse';
    results: Array<{
      __typename?: 'Sku';
      id: string;
      name: string;
      tier: Types.SkuTier;
      period: Types.SubscriptionInterval;
      price: number;
      numberOfSessions: number;
      unitPrice: number;
      family: Types.SkuFamily;
      timeInMinutes: number;
    }>;
  };
  activeCustomerSubscriptions: Array<{
    __typename?: 'CustomerSubscription';
    id: string;
  }>;
};

export const BookHourlyCoachingFormCoachFragmentDoc = gql`
  fragment BookHourlyCoachingForm_Coach on Coach {
    id
    newExperience
    hourlyRate
    user {
      id
      firstName
      lastName
      pictureLink
    }
    mostRecentOrder {
      hourlyOrder {
        timeInMinute
      }
    }
    tier
  }
`;
export const BookHourlyCoachingFormCoachingFocusFragmentDoc = gql`
  fragment BookHourlyCoachingForm_CoachingFocus on CoachingFocus {
    ...ServicesDescription_CoachingFocus
  }
  ${ServicesDescriptionCoachingFocusFragmentDoc}
`;
export const BookHourlyCoachingFormCreateOrderDocument = gql`
  mutation BookHourlyCoachingForm_CreateOrder(
    $coachUrn: CoachUrn!
    $hourlyOrder: HourlyOrderInput!
    $numberOfCharges: Int!
    $categoryUrn: CategoryUrn
  ) {
    createOrder(
      coachUrn: $coachUrn
      hourlyOrder: $hourlyOrder
      numberOfCharges: $numberOfCharges
      categoryUrn: $categoryUrn
    ) {
      id
    }
  }
`;
export type BookHourlyCoachingFormCreateOrderMutationFn =
  Apollo.MutationFunction<
    BookHourlyCoachingFormCreateOrderMutation,
    BookHourlyCoachingFormCreateOrderMutationVariables
  >;

/**
 * __useBookHourlyCoachingFormCreateOrderMutation__
 *
 * To run a mutation, you first call `useBookHourlyCoachingFormCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookHourlyCoachingFormCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookHourlyCoachingFormCreateOrderMutation, { data, loading, error }] = useBookHourlyCoachingFormCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      numberOfCharges: // value for 'numberOfCharges'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useBookHourlyCoachingFormCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookHourlyCoachingFormCreateOrderMutation,
    BookHourlyCoachingFormCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookHourlyCoachingFormCreateOrderMutation,
    BookHourlyCoachingFormCreateOrderMutationVariables
  >(BookHourlyCoachingFormCreateOrderDocument, options);
}
export type BookHourlyCoachingFormCreateOrderMutationHookResult = ReturnType<
  typeof useBookHourlyCoachingFormCreateOrderMutation
>;
export type BookHourlyCoachingFormCreateOrderMutationResult =
  Apollo.MutationResult<BookHourlyCoachingFormCreateOrderMutation>;
export type BookHourlyCoachingFormCreateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    BookHourlyCoachingFormCreateOrderMutation,
    BookHourlyCoachingFormCreateOrderMutationVariables
  >;
export const BookHourlyCoachingFormUpdateOrderDocument = gql`
  mutation BookHourlyCoachingForm_UpdateOrder(
    $id: OrderUrn!
    $hourlyOrder: HourlyOrderInput
    $categoryUrn: CategoryUrn
  ) {
    updateOrder(id: $id, hourlyOrder: $hourlyOrder, categoryUrn: $categoryUrn) {
      id
    }
  }
`;
export type BookHourlyCoachingFormUpdateOrderMutationFn =
  Apollo.MutationFunction<
    BookHourlyCoachingFormUpdateOrderMutation,
    BookHourlyCoachingFormUpdateOrderMutationVariables
  >;

/**
 * __useBookHourlyCoachingFormUpdateOrderMutation__
 *
 * To run a mutation, you first call `useBookHourlyCoachingFormUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookHourlyCoachingFormUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookHourlyCoachingFormUpdateOrderMutation, { data, loading, error }] = useBookHourlyCoachingFormUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useBookHourlyCoachingFormUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookHourlyCoachingFormUpdateOrderMutation,
    BookHourlyCoachingFormUpdateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookHourlyCoachingFormUpdateOrderMutation,
    BookHourlyCoachingFormUpdateOrderMutationVariables
  >(BookHourlyCoachingFormUpdateOrderDocument, options);
}
export type BookHourlyCoachingFormUpdateOrderMutationHookResult = ReturnType<
  typeof useBookHourlyCoachingFormUpdateOrderMutation
>;
export type BookHourlyCoachingFormUpdateOrderMutationResult =
  Apollo.MutationResult<BookHourlyCoachingFormUpdateOrderMutation>;
export type BookHourlyCoachingFormUpdateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    BookHourlyCoachingFormUpdateOrderMutation,
    BookHourlyCoachingFormUpdateOrderMutationVariables
  >;
export const BookHourlyCoachingFormInitialLoadDocument = gql`
  query BookHourlyCoachingForm_InitialLoad($coachUrn: CoachUrn!) {
    skus(period: ONE_TIME, count: 1000) {
      results {
        id
        name
        tier
        period
        price
        numberOfSessions
        unitPrice
        family
        timeInMinutes
      }
    }
    activeCustomerSubscriptions: customerSubscriptions(
      coachUrn: $coachUrn
      statuses: [ACTIVE]
    ) {
      id
    }
  }
`;

/**
 * __useBookHourlyCoachingFormInitialLoadQuery__
 *
 * To run a query within a React component, call `useBookHourlyCoachingFormInitialLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookHourlyCoachingFormInitialLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookHourlyCoachingFormInitialLoadQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useBookHourlyCoachingFormInitialLoadQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  > &
    (
      | {
          variables: BookHourlyCoachingFormInitialLoadQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  >(BookHourlyCoachingFormInitialLoadDocument, options);
}
export function useBookHourlyCoachingFormInitialLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  >(BookHourlyCoachingFormInitialLoadDocument, options);
}
export function useBookHourlyCoachingFormInitialLoadSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BookHourlyCoachingFormInitialLoadQuery,
    BookHourlyCoachingFormInitialLoadQueryVariables
  >(BookHourlyCoachingFormInitialLoadDocument, options);
}
export type BookHourlyCoachingFormInitialLoadQueryHookResult = ReturnType<
  typeof useBookHourlyCoachingFormInitialLoadQuery
>;
export type BookHourlyCoachingFormInitialLoadLazyQueryHookResult = ReturnType<
  typeof useBookHourlyCoachingFormInitialLoadLazyQuery
>;
export type BookHourlyCoachingFormInitialLoadSuspenseQueryHookResult =
  ReturnType<typeof useBookHourlyCoachingFormInitialLoadSuspenseQuery>;
export type BookHourlyCoachingFormInitialLoadQueryResult = Apollo.QueryResult<
  BookHourlyCoachingFormInitialLoadQuery,
  BookHourlyCoachingFormInitialLoadQueryVariables
>;
